import React, { useEffect } from 'react';
import "./SearchServiceGoogleAPI.scss";
import GoogleService from '../../../services/GoogleService';
import { SearchOutlined,AudioOutlined } from '@ant-design/icons';

import Enums from '../../../misc/Enums';
import { Input, Skeleton,Select } from 'antd';
import { Position } from '@react-pdf-viewer/core';
import { EyeOutlined } from '@ant-design/icons';

export default function SearchServiceGoogleAPI(props) {
    const [searchText, setSearchText] = React.useState("");
    const [searchList, setSearchList] = React.useState([]);
    const [searchType, setSearchType] = React.useState(1);
    const [isLoading, setIsLoading] =  React.useState(false);

    const { Search } = Input;
    const suffix = (
      <AudioOutlined
        style={{
          fontSize: 16,
          color: '#1677ff',
        }}
      />
    );

    useEffect(() => {
      setSearchList([])
      // setSearchText("")
      if (searchText !== "")
            onSearch()
   }, [searchType]);

   const handleChange = (value) => {
      setSearchType(value)
    };
    

    const onSearch = async (e) =>
    {    
        setIsLoading(true)
        var selectedOption = searchType === 0 ? "youtube" : searchType === 1 ? "google.search" : "google.image"
        GoogleService.searchGoogleService(selectedOption, searchText).then((response) => {
            if (response?.data) {
               var varitems = response.data.items;
               var searchResult = [];
               if (selectedOption === Enums.ResourcesType.isYoutube) {
                  varitems.map((item) => {
                     var searchItem = {
                        type: Enums.ResourcesType.isYoutube, videoId: item.id.videoId, title: item.snippet.channelTitle,
                        description: item.snippet.description, image: item.snippet.thumbnails["high"].url
                     }
                     searchResult.push(searchItem);
                  })
               }
               if (selectedOption === Enums.ResourcesType.isGoogleImage) {
                  varitems.map((item) => {
                     var searchItem = {
                        type: Enums.ResourcesType.isGoogleImage, link: item.link, title: item.title,
                        description: item.snippet, image: item.link
                     }
                     searchResult.push(searchItem);
                  })
               }
               if (selectedOption === Enums.ResourcesType.isGoogleSearch) {
                  varitems.map((item) => {
                     var searchItem = {
                        type: Enums.ResourcesType.isGoogleSearch, link: item.link, title: item.title,
                        description: item.snippet, image: item.pagemap.cse_thumbnail ? item.pagemap.cse_image[0].src : ""
                     }
                     searchResult.push(searchItem);
                  })
               }
               setSearchList(searchResult)
               setIsLoading(false)
            }
            else {
               setIsLoading(false)
               // No Data
            }
         }).catch((ex) => {
            setIsLoading(false)
            // message.error(ex.message)
         })
    }

    return(
        <>
            <div className="title">
               <div style={{color : 'white' , fontWeight : 'bold', width : '100%', fontSize : '24px' }}>
                  Search the internet
               </div>
            </div>        
            <div className="selection">
              <div style={{justifyItems : "center",
                           color : "white",
                           fontSize : "18px",
                           textAlign : "center", 
                           alignItems : "center", paddingRight : "5px"}}>Search Type : </div>
              <div>
              <Select
                  defaultValue="Website Search"
                  style={{ width: 200 }}
                   onChange={value => handleChange(value)}
                  options={[
                  { value: 1, label: 'Website Search' },
                  { value: 0, label: 'Video Search' },
                  { value: 2, label: 'Image Search' },
                  ]}
               />            
               </div>   
               {/* <div style={{color : 'white' , fontWeight : 'bold', width : '100%', fontSize : '18px' }}>
                  {searchType=== 0 ? "VIDEO SEARCH" : searchType=== 1 ? "WEBSITE SEARCH" : "IMAGE SEARCH"}
               </div> */}
            </div>
            <div className='container-search'>
                <div className='search-group'>
                   <Input size="large"  onChange={(e) => setSearchText(e.target.value)}  onPressEnter={onSearch}
                        value={searchText} placeholder="Search Keywords" prefix={<SearchOutlined />} style={{borderRadius : '5px'}} />
                </div>
            </div>
            {!isLoading ? <div className='result-container'>
               {
               searchList.map((result) =>
               {
                  return(
                     <>
                        <div className='image-container'  > 
                        <div 
                             onClick={()=> window.open(searchType=== 0 ? `${process.env.REACT_APP_YOUTUBE_URL}${result.videoId}` : result.link, "_blank")}
                             style={{display : "block", 
                                     cursor : "pointer",
                                     position : "absolute" , 
                                     fontSize : "20px", 
                                     padding : "5px", 
                                     borderRadius : "5px" ,
                                    //  backgroundColor : "gray", 
                                     width : "30px", 
                                     height : "25px",
                                     right : "65px", 
                                     alignContent : "center",
                                     justifyContent : "center",
                                     alignItems : "center",
                                    //  top : "-10px",
                                     color: "white", 
                                     zIndex : "999"}}><EyeOutlined style={{borderRadius : "5px", boxShadow : "3px 3px #656f80", backgroundColor : "#47484a", padding : "5px"}} /></div>                           
                           <img className='image-result' src={result.image} onClick={() => props.add(result)}/>
                        </div>
                        <div style={{ width : '250px', margin : 'auto', paddingTop : '10px'}}>
                           <div className='author-style'  >{result.title}</div>
                           <div className='description-style' >{result.description}</div>                          
                        </div>
                        <br/>               
                     </>
                  )
               })   
               }
            </div>:
            <div className='result-container'>
               <div className='image-container' > 
                <Skeleton.Image active className='image-result' style={{width : "250px" , height : "180px"}}/>
               </div>
               <div style={{ width : '250px', margin : 'auto', paddingTop : '10px'}}>
                  <div className=' author-style'  ><Skeleton.Input active style={{width : "250px" }}/></div>
                  <div className=' description-style' ><Skeleton.Input active  style={{width : "250px" }}/></div>    
               </div>           
            </div>
            }
        </>
    )
}